/**
 * Returns the combined height of visible nano banners and the main site header,
 * for positioning fixed UI below the header stack.
 *
 * @returns {string} Top offset in pixels (e.g. `"120px"`).
 */
function getHeaderHeight() {
    // Calculate nano banner(s) height
    const nanoBannersEls = document.querySelectorAll('.nano-banner-element');
    const nanoBannerHeight = Array.from(nanoBannersEls).reduce((sum, element) => sum + element.offsetHeight, 0);

    // Get site header height
    const siteHeaderEl = document.getElementById('site-header');
    const siteHeaderHeight = siteHeaderEl?.offsetHeight || 0;

    return `${nanoBannerHeight + siteHeaderHeight}px`;
}

export { getHeaderHeight };
